import { TECHNICS } from "./technics";

export const createPerson = (props) => {
    const { lvl, livesInner, forceInner, extrasInner, extrasSlotsInner, technicsInner } = props;

    let lives = livesInner ? Math.min(MaxLivesByLvl[lvl], livesInner) : MaxLivesByLvl[lvl];
    let force = forceInner? Math.min(MaxForceKoefByLvl[lvl], forceInner) : MaxForceKoefByLvl[lvl];

    let extras = extrasInner || []; // это конкретные экстра, мы это попозже заполняем исходя из выбранных предметов
    let extrasSlots = extrasSlotsInner ? extrasSlotsInner : (extrasSlotsInnerByLvl[lvl] || 0); // это сколько слотов для тыканья
    let extrasSlotsMinCount = extrasSlotsMinCountBySlotsCount[extrasSlots] || 0; // это сколько минимально нужно карточек

    // тут проверка будет 
    let technics = technicsInner || defTechincs;
    let strikesCount = Math.max( MaxStrikesCountByLvl[lvl], 3 );
    let vigilance = Math.max( MaxVigilanceKoefByLvl[lvl], 1 );

    return {
        lives,
        innerLives: lives,
        force,
        name: 'Игрок',
        extras,
        extrasSlots,
        extrasSlotsMinCount,
        technics,
        strikesCount,
        vigilance,
        defdarkness: 0,
        defcold: 0,
        defphisics: 0
    }

}

const MaxLivesByLvl = {
    1: 7,
    2: 10,
    3: 13,
    4: 17,
    5: 21,
    6: 25,
    7: 30,
    8: 35,
    9: 40,
    10: 45,
    11: 50,
    12: 55,
    13: 60,
    14: 65,
    15: 70
}

const MaxVigilanceKoefByLvl = {
    1: 10,
    2: 12,
    3: 14,
    4: 17,
    5: 20,
    6: 23,
    7: 27,
    8: 31,
    9: 35,
    10: 39,
    11: 44,
    12: 49,
    13: 54,
    14: 59,
    15: 64
}

const MaxForceKoefByLvl = {
    1: 1,
    2: 1.1,
    3: 1.2,
    4: 1.4,
    5: 1.6,
    6: 1.8,
    7: 2.1,
    8: 2.4,
    9: 2.7,
    10: 3,
    11: 3.3,
    12: 3.6,
    13: 4,
    14: 4,
    15: 4
}

const MaxStrikesCountByLvl = {
    1: 3,
    2: 3,
    3: 3,
    4: 3,
    5: 4,
    6: 4,
    7: 4,
    8: 4,
    9: 4,
    10: 5,
    11: 5,
    12: 5,
    13: 5,
    14: 5,
    15: 5
}

const extrasSlotsInnerByLvl = {
    1: 0,
    2: 1,
    3: 1,
    4: 1,
    5: 1,
    6: 1,
    7: 2,
    8: 2,
    9: 2,
    10: 2,
    11: 3,
    12: 3,
    13: 3,
    14: 3,
    15: 3
}

const extrasSlotsMinCountBySlotsCount = {
    0: 0,
    1: 3,
    2: 5,
    3: 8
}

const defTechincs = {
    strike: [
        { key: 'martelo', type: 'strike', strength: TECHNICS.martelo.strength },
        { key: 'armada', type: 'strike', strength: TECHNICS.armada.strength },
        { key: 'bencao', type: 'strike', strength: TECHNICS.bencao.strength },
        { key: 'rasteira', type: 'strike', strength: TECHNICS.rasteira.strength },
        { key: 'compassa', type: 'strike', strength: TECHNICS.compassa.strength },
    ],
    defence: [
        { key: 'diagonale', type: 'defence' },
        { key: 'middle1', type: 'defence' },
        { key: 'jump', type: 'defence' },
        
        { key: 'goback', type: 'defence' },

        { key: 'salto', type: 'defence' },
        { key: 'beduin', type: 'defence' },
        { key: 'boche', type: 'defence' }
    ]
}